import * as Styles from './styles';
import { ReaderStatusProps } from './types';
import { READER_TONE_COLOR } from './helpers';

// A Clover reader's status: a dot and the server's word ("Ready", "In a
// sale", "Offline", ...). The word and tone come from Main (plan §1); this
// only lays them out.
export const ReaderStatus = ({
  label,
  reader,
  nameOnly,
  dotAfter,
  className,
  testId = 'reader-status',
}: ReaderStatusProps) => {
  const dot = (
    <Styles.Dot
      aria-hidden
      data-tone={reader.tone}
      data-testid={`${testId}-dot`}
      $color={READER_TONE_COLOR[reader.tone] ?? READER_TONE_COLOR.muted}
    />
  );
  const full = label ? `${label} · ${reader.word}` : reader.word;
  const text = nameOnly ?? full;

  return (
    <Styles.Container
      data-testid={testId}
      className={className}
      data-tone={reader.tone}
      title={nameOnly ? `${nameOnly} · ${reader.word}` : full}
    >
      {!dotAfter && dot}
      <Styles.Text>{text}</Styles.Text>
      {dotAfter && dot}
    </Styles.Container>
  );
};

export { findReader, lastSeenText, READER_TONE_COLOR } from './helpers';
export type { ReaderStatusProps };
